export enum EVEN_SHOT_TAB {
  ALL_SRM = 'All Even Shots',
  RUNNERS = 'Runners',
}
